import reactUseMeasure from "react-use-measure";
import { ResizeObserver } from "@juggle/resize-observer";

export default function useMeasure(options) {
  return reactUseMeasure({ polyfill: ResizeObserver, ...options });
}
